export default {
  data() {
    return {
      valid: true
    };
  },
  methods: {
    displayDocumentRevTypeA(u) {
      let r1 = u.r1;
      let r2 = u.r2;
      let r3 = u.r3;
      return r1 + "." + r2 + "." + r3;
    },
    docRev0_0(u) {
      let r1 = u.r1;
      let r2 = u.r2;
      return r1 + "." + r2;
    },
    docRevr1_r2_r3_r4(u) {
      let r1 = u.r1;
      let r2 = u.r2;
      let r3 = u.r3;
      let r4 = u.r4;
      return r1 + "." + r2 + "." + r3 + "." + r4;
    },
    docRevr2_r3_r4_r5(u) {
      let r2 = u.r2;
      let r3 = u.r3;
      let r4 = u.r4;
      let r5 = u.r5;
      return r2 + "." + r3 + "." + r4 + "." + r5;
    },
    docRevr0_r1_r2_r3_r4_r5(u) {
      let r0 = u.r0;
      let r1 = u.r1;
      let r2 = u.r2;
      let r3 = u.r3;
      let r4 = u.r4;
      let r5 = u.r5;
      // eslint-disable-next-line
      return r0 + "." + r1 + "." + r2 + "." + r3 + "." + r4 + "." + r5;
    },
    docRevr0_r1_r2_r3_r4_r5_r6(u) {
      let r0 = u.r0;
      let r1 = u.r1;
      let r2 = u.r2;
      let r3 = u.r3;
      let r4 = u.r4;
      let r5 = u.r5;
      let r6 = u.r6;
      // eslint-disable-next-line
      return r0 + "." + r1 + "." + r2 + "." + r3 + "." + r4 + "." + r5 + "." + r6;
    },
    docRev0_0_0(u) {
      let r1 = u.r1;
      let r2 = u.r2;
      let r3 = u.r3;
      return r1 + "." + r2 + "." + r3;
    },
    docRev0_0_0_0_0_0(u) {
      let r0 = u.r1;
      let r1 = u.r1;
      let r2 = u.r2;
      let r3 = u.r3;
      let r4 = u.r4;
      let r5 = u.r5;
      // eslint-disable-next-line
      return r0 + "." + r1 + "." + r2 + "." + r3 + "." + r4 + "." + r5;
    },
    docRevModDisplay(mod) {
      if (mod > 1 && mod < 1.99) {
        return "Transform";
      } else if (mod > 2 && mod < 2.99) {
        return "Major";
      } else if (mod > 3 && mod < 3.99) {
        return "Minor";
      } else if (mod > 4 && mod < 4.99) {
        return "Business";
      } else if (mod > 5 && mod < 5.99) {
        return "Comment";
      } else {
        return "Special";
      }
    }
  }
};
